// extracted by mini-css-extract-plugin
export default {"lifeBtm":"JobsList_lifeBtm__n2SIB","noJobs":"JobsList_noJobs__Mfrr6","loadMoreBtnItem":"JobsList_loadMoreBtnItem__BzPlf","loadMoreBtn":"JobsList_loadMoreBtn__bFFJc"};